import React, { Component } from 'react'
import Avatar from 'react-avatar-edit'
import { isImage } from '../../Templates/functions'
class ImageUploader extends Component {
    constructor(props) {
        super(props)
        this.profileImage = React.createRef()
        this.state = {
            profileImage: this.props.profileImage,
            showingUploadForm: false,
            img: ""
        }
    }

    onClose = () => {
        this.setState({ preview: null })
    }

    onCrop = (preview) => {
        // this.resizeImage(preview)
        this.setState({ img: preview })
    }

    onBeforeFileLoad = (elem) => {
        let file = elem.target.files[0]
        if (file) {
            let ext = file.name.split('.').pop()
            if (!isImage(ext)) {
                alert("Only png, tiff, jpg or jpeg images are supported. ");
                elem.target.value = "";
            }
        };
    }

    toDataURL = (url, callback) => {
        var xhr = new XMLHttpRequest();

        xhr.onload = function () {
            var reader = new FileReader();
            reader.onloadend = function () {
                callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }
    
    resizeImage(base64Str) {
        var img = new Image();
        img.src = base64Str;
        img.onload = () => {
            var canvas = document.createElement('canvas');
            var MAX_WIDTH = 400;
            var MAX_HEIGHT = 400;
            var width = img.width;
            var height = img.height;
            
            if (width > height) {
                if (width > MAX_WIDTH) {
                    height *= MAX_WIDTH / width;
                    width = MAX_WIDTH;
                }
            } else {
                if (height > MAX_HEIGHT) {
                    width *= MAX_HEIGHT / height;
                    height = MAX_HEIGHT;
                }
            }
            canvas.width = width;
            canvas.height = height;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, width, height);
            return this.props.setProfilePicture(canvas.toDataURL());
        }
    }
    
    handleSubmit = (event) => {
        event.preventDefault()
        this.toDataURL(this.state.img, (myBase64) => this.setState({ showingUploadForm: false, profileImage: myBase64, img: "" }, () => {
            this.resizeImage(myBase64)
            console.log(this.props)
        }))

    }


    render() {
        return <div style={{textAlign: "center"}}>
                    <h3 style={{textAlign: "center"}}>Profile Image </h3>
                        <Avatar
                               ref={this.profileImage}
                               width={350}
                               height={350}
                               borderStyle={{border: "2px dashed rgb(151, 151, 151)", borderRadius: "195px"}}
                               onCrop={this.onCrop}
                               onClose={this.onClose}
                               onBeforeFileLoad={this.onBeforeFileLoad}
                               src={this.state.src}
                           />
                       <button onClick={this.handleSubmit}>Submit</button>
                </div>
    }
}

export default ImageUploader